import { memo } from 'react';
import { IconTable, TableHead } from '@wg/wows-react-uikit';

import { SEASON_TYPES } from '~/constants';
import { isChinese } from '~/helpers/realm';

import headers from './headers.settings';
import TableHeadCell from '../Table/TableHeadCell';

import type { IconTableTypes } from '@wg/wows-react-uikit/components/IconTable/IconTable';

interface ClansRatingTableHeadProps {
  isCrossRealmLadder?: boolean;
  isOldSeason?: boolean;
  seasonType?: string;
  stickyContainerId: string;
}

const ClansRatingTableHead = ({ isOldSeason = false, seasonType, stickyContainerId }: ClansRatingTableHeadProps) => {
  const isBrawl = seasonType === SEASON_TYPES.BRAWL;
  const isCnRealm = isChinese();

  return (
    <TableHead stickyContainerId={stickyContainerId} isActiveSticky={false}>
      <>
        {headers(isOldSeason, isBrawl).map((item, index) => (
          <TableHeadCell
            key={index}
            isHidden={item.isHidden}
            modify={item.modify}
            tooltipText={item.tooltipText}
            tooltipParam={!isCnRealm ? item.tooltipParam : ''}
          >
            {item.glyph ? <IconTable glyph={item.glyph as IconTableTypes} /> : null}
            {item.text}
          </TableHeadCell>
        ))}
      </>
    </TableHead>
  );
};

export default memo(ClansRatingTableHead);
